'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Popover', []).directive('rmPopover', require('./directives/PopoverDirective')).factory('PopoverService', require('./services/PopoverService'));